import { render } from 'vue'
import AppTooltipBasic from '~/components/App/TooltipBasic/AppTooltipBasic.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltipv2', {
    mounted(el: HTMLElement, binding) {
      if (!binding.value) {
        render(null, el)
        return
      }

      const placement = ['top', 'right', 'bottom', 'left'].includes(
        binding.arg ?? '',
      )
        ? (binding.arg as 'top' | 'right' | 'bottom' | 'left')
        : 'bottom'

      const tooltip = h(AppTooltipBasic, {
        anchorReference: el,
        text: binding.value,
        placement,
        variant: binding.modifiers.dark ? 'dark' : 'light',
      })

      el.dataset.tooltipValue = binding.value

      render(tooltip, el)
    },
    updated(el: HTMLElement, binding) {
      if (!binding.value) {
        render(null, el)
        return
      }

      const placement = ['top', 'right', 'bottom', 'left'].includes(
        binding.arg ?? '',
      )
        ? (binding.arg as 'top' | 'right' | 'bottom' | 'left')
        : 'bottom'

      const tooltip = h(AppTooltipBasic, {
        anchorReference: el,
        text: binding.value,
        placement,
        variant: binding.modifiers.dark ? 'dark' : 'light',
      })

      render(tooltip, el)
    },
    unmounted(el: HTMLElement) {
      render(null, el)
    },
  })
})
